module.exports = __webpack_public_path__ + "static/img/Drew-Brees-Record-King.5b5c912.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Drew-Brees-Record-King.gif
// module id = WlvW
// module chunks = 1